import { useEffect, useState } from "react";
import { generateAuthHeader, generateTokenAuthHeader } from "../../commonfunctions/authentication";
import { log } from "../../commonfunctions/logger";
import { getSubdomain } from "../../context/ContextApp";
import { useHistory } from "react-router-dom";
import { subdomainTypes } from "../../context/availableSubdomains";
import { updateCurrentOrder } from "../../redux/actions/orders";
import { useDispatch } from "react-redux";

interface SliderDetail {
  id: number;
  image: string;
  link: string;
  index: number;
  responsive: boolean;
  activate: boolean;
  slider: number;
}

interface SliderDetailResponse {
  slider: SliderDetail[];
  slider_responsive: SliderDetail[];
}

const HomePage = () => {
  const [sliderResponse, setSliderResponse] = useState<SliderDetailResponse | null>(null);
  const appBranch = getSubdomain();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const getSliders = async () => {
        try {
          const res = await fetch(
            `${process.env.REACT_APP_HONEYBEE_ROOT_API}/sliders/webstore-${appBranch}`,
            generateTokenAuthHeader()
          );
          if (res.ok) {
            const data = await res.json();
            setSliderResponse(data);
          } else {
            const error = await res.text();
            throw error;
          }
        } catch (error) {
          log(error, "Failed to get cart at CartPage");
        }
      };

      const getCurrentOrder = async () => {
        try {
          const res = await fetch(
            `${process.env.REACT_APP_HALFBACK_ROOT_API}/orders/current_order`,
            generateAuthHeader()
          );
          if (res.ok) {
            const data = await res.json();
            dispatch(updateCurrentOrder(data));
          } else {
            const error = await res.text();
            throw error;
          }
        } catch (error) {
          log(error, "Failed to get cart at CartPage");
        }
      };

      if (appBranch === subdomainTypes.CA) {
        history.push("/store/cart")
      }

      getCurrentOrder();
      getSliders()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


  return (
    <div className="home-page">
      <h2>What's New</h2>
      <section className="slider_section">
        {sliderResponse?.slider && sliderResponse.slider.map((slider, index) => (
          <a href={slider.link} key={index} target="_blank" className="slider_card">
            <img
              alt='slider image'
              src={slider.image}
              className="slider-img"
            />
          </a>
        ))
        }
      </section>
    </div>
  );
};

export default HomePage;
